import { render, staticRenderFns } from "./HlOnboardingOverviewPage.vue?vue&type=template&id=06d2a9a3&scoped=true&"
import script from "./HlOnboardingOverviewPage.vue?vue&type=script&lang=ts&"
export * from "./HlOnboardingOverviewPage.vue?vue&type=script&lang=ts&"
import style0 from "./HlOnboardingOverviewPage.vue?vue&type=style&index=0&id=06d2a9a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d2a9a3",
  null
  
)

export default component.exports